var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("mh-category-modal", {
    ref: "modal",
    attrs: {
      id: _vm.id,
      title: _vm.title,
      "category-id": _vm.categoryId,
      type: _vm.type,
    },
    on: { "data:loaded": _vm.injectItemData },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }